import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Heart, Lock } from "lucide-react";
import { CATEGORY_IMAGES } from "@/constants/categoryImages";

export function CourseTile({ c, i, count, onOpen, favorited, onFav, locked }) {
  const Icon = Icons[c.icon] || Icons.Sparkles;
  const img = c.image_url || CATEGORY_IMAGES[c.id];
  return (
    <motion.div data-testid={`featured-course-${c.id}`}
      initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: i * 0.03 }}
      onClick={() => onOpen(c.id)} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") onOpen(c.id); }}
      className="cursor-pointer text-left bg-white rounded-3xl card-soft overflow-hidden hover:-translate-y-0.5 transition-smooth flex flex-col">
      <div className="relative h-40 overflow-hidden bg-[#F7F2EA]">
        {img ? (
          <img src={img} alt="" loading="lazy" className="h-full w-full object-cover" style={{ objectPosition: "50% 32%" }} />
        ) : (
          <div className="h-full w-full" style={{ background: `linear-gradient(135deg, ${c.color || "#7B628B"}, #291B2D)` }} />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#291B2D]/70 to-transparent" />
        {locked ? (
          <span data-testid={`course-locked-${c.id}`}
            className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-[#291B2D]/85 text-white text-[11px] font-semibold px-2.5 py-1 backdrop-blur">
            <Lock size={12} /> Members
          </span>
        ) : onFav && (
          <button
            data-testid={`course-fav-${c.id}`}
            aria-label={favorited ? "Remove from saved courses" : "Save course"}
            aria-pressed={favorited}
            onClick={(e) => { e.stopPropagation(); onFav(c.id); }}
            className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center hover:scale-105 active:scale-95 transition-smooth">
            <Heart className={favorited ? "fill-[#C89B55] text-[#C89B55]" : "text-[#291B2D]"} size={17} />
          </button>
        )}
        <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2.5 text-white">
          <span className="w-9 h-9 rounded-xl bg-white/90 flex items-center justify-center shrink-0"><Icon className="text-[#291B2D]" size={16} /></span>
          <span className="font-heading text-lg leading-tight">{c.title}</span>
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        {c.subtitle && <p className="text-[10px] uppercase tracking-widest text-[#C89B55] font-semibold mb-1">{c.subtitle}</p>}
        <p className="text-sm text-[#291B2D]/60 leading-relaxed line-clamp-2">{c.description}</p>
        <p className="text-[11px] uppercase tracking-widest text-[#291B2D]/45 mt-3">{count} {count === 1 ? "lesson" : "lessons"}</p>
      </div>
    </motion.div>
  );
}
